import {
  Button,
  CollectionCompilerTemplate,
  CompilerContent,
  CompilerContentBlock,
  Header,
  Input,
} from '@ws/shared';
import { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { v4 } from 'uuid';

import { Page } from '../../components/Page';
import { Sidebar } from '../../components/Sidebar';
import { useFetchPreviewByLinkKey } from '../../resources/hooks/useFetchPreviewByLinkKey';

import styles from './ReviewPage.module.css';
import { useList } from 'react-use';
import { CommentItem } from './CommentItem';

interface Comment {
  id: string;
  noteId: string;
  range: { from: number; to: number };
  text: string;
}

interface HighlightDraft {
  noteId: string;
  from: number;
  to: number;
  save: (commentId: string) => void;
}

export function ReviewPage() {
  const { linkKey } = useParams<{ linkKey: string }>();

  const {
    data: preview,
    isLoading,
    isPlaceholderData,
  } = useFetchPreviewByLinkKey(linkKey as string);

  const contentRef = useRef<HTMLDivElement | null>(null);
  const [highlightDraft, setHighlightDraft] = useState<HighlightDraft | null>(null);
  const [commentText, setCommentText] = useState<string>('');
  const [commentList, { push: pushComment }] = useList<Comment>([]);

  function setSelectionWithNote(noteId: string) {
    return function (
      selection: { from: number; to: number; save: (commentId: string) => void } | null,
    ) {
      if (!selection) {
        setHighlightDraft(null);
        return;
      }

      // debugger;
      setHighlightDraft({ noteId, ...selection });
    };
  }

  function saveComment() {
    if (!highlightDraft) return;

    const commentId = v4();
    highlightDraft?.save(commentId);
    pushComment({
      id: commentId,
      noteId: highlightDraft?.noteId,
      text: commentText,
      range: {
        from: highlightDraft?.from,
        to: highlightDraft?.to,
      },
    });
    setHighlightDraft(null);
    setCommentText('');
  }

  if (isLoading || isPlaceholderData) {
    return <>Loading...</>;
  }

  if (!preview) {
    return <>{'Предпоказ недоступен'}</>;
  }

  return (
    <Page className={styles['preview-page']}>
      <Sidebar />
      <div className={styles['preview-page__playground-wrapper']}>
        <Header
          className={styles['preview-page__header']}
          title={<Input readOnly variant="shapeless" value={preview.title} />}
        />
        <div ref={contentRef} className={styles['preview-page__content']}>
          <CollectionCompilerTemplate
            compiledNodes={preview.content.map((part) => (
              <CompilerContentBlock key={part.id} noNoteHighlight>
                <CompilerContent
                  type="highlights"
                  entity={part}
                  setSelection={setSelectionWithNote(part.id)}
                />

                <div
                  style={{ position: 'absolute', top: 0, right: -300, width: 200, marginTop: 16 }}
                >
                  {commentList
                    .filter((comment) => comment.noteId === part.id)
                    .map((comment) => (
                      <CommentItem key={comment.id} comment={comment} />
                    ))}
                </div>
              </CompilerContentBlock>
            ))}
          />
        </div>

        <div style={{ position: 'absolute', top: 60, right: 0, width: 400, overflow: 'auto' }}>
          {highlightDraft && (
            <div style={{ backgroundColor: 'lightgrey', borderRadius: 4, padding: '16px' }}>
              <textarea
                style={{ width: '100%' }}
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
              />
              <Button onClick={saveComment}>Save</Button>
            </div>
          )}
        </div>
      </div>
    </Page>
  );
}
